<template>
  <o-modal
    :active.sync="isActive"
    content-class="tw-h-1/2 tw-w-1/2"
  >
    <PortfolioCreator
      @submit="forwardSubmit"
    />
  </o-modal>
</template>

<script>
import PortfolioCreator from '@frontend/ui/components/utils/PortfolioCreator.vue';

export default {
  name: 'PortfolioCreatorDialog',
  components: { PortfolioCreator },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isActive: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit('input', v);
      },
    },
  },
  methods: {
    forwardSubmit(payload) {
      this.$emit('submit', payload);
      this.$emit('input', false);
    },
  },
};
</script>

<style scoped>

</style>


